"use strict";exports.ordinalSuffix=function(t){var n=t%100,r=["th","st","nd","rd"];return"".concat(t).concat(r[(n-20)%10]||r[n]||r[0])};
//# sourceMappingURL=ordinalSuffix.cjs.map
